<template>
    <div class="hp-calendar" v-if="data.length">
        <z-caption
            class="u-bottom-margin--xl"
            size="xl"
            :href="`/${$root.lang}/investors/calendar/`"
            uppercase
        >
            <span v-html="text.title"></span>
        </z-caption>
        <z-card class="hp-calendar__card">
            <template #content>
                <slider v-if="upcomingEvents.length">
                    <slide v-for="(item, index) in upcomingEvents" :key="index">
                        <div class="hp-calendar-slide">
                            <date-block
                                size="xl"
                                :date="item.dateFrom.timestamp"
                                :date-end="item.dateFrom.timestamp === item.dateTo.timestamp ? '' : item.dateTo.timestamp"
                                class="hp-calendar-slide__date"
                            />
                            <div class="hp-calendar-slide__info">
                                <z-caption size="m" weight="500">
                                    <z-link theme="black" :href="`/${$root.lang}/investors/calendar/`">
                                        <span v-html="item.name"></span>
                                    </z-link>
                                </z-caption>
                            </div>
                        </div>
                    </slide>
                </slider>
                <template v-else>
                    <z-caption size="xl" tag="h1" class="black-text">
                        <span v-html="text.noEvents.title"></span>
                    </z-caption>
                    <p v-html="text.noEvents.description"></p>
                </template>
            </template>
        </z-card>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'calendar',
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            text: {
                title: localize({
                    ru: 'Календарь',
                    en: 'Calendar'
                }),
                noEvents: {
                    title: localize({
                        ru: 'Мероприятий не&nbsp;запланировано',
                        en: 'No events planned'
                    }),
                    description: localize({
                        ru: 'Обновление последует в&nbsp;ближайшее время',
                        en: 'Update will follow soon'
                    })
                }
            }
        }
    },
    methods: {
        isEnded (date) {
            return date && date * 1000 > new Date().getTime()
        }
    },
    computed: {
        upcomingEvents () {
            return this.data.filter(item => this.isEnded(item.dateTo.timestamp))
        }
    }
}
</script>

<style lang="scss">
.hp-calendar {
    &__card {
        min-height: 400px !important;

        @include breakpoint (v-tablet) {
            min-height: auto !important;
        }
    }
}

.hp-calendar-slide {
    display: flex;
    flex-direction: column;
    @include padding-level(bottom, M);

    @include breakpoint (tablet) {
        padding-bottom: 0;
    }

    &__date {
        flex-shrink: 0;
    }

    &__info {
        padding-top: $token-spacers-xs;
    }

    &__info-header {
        @include padding-level(bottom, S);
        @include margin-level(bottom, XS);
        border-bottom: 2px solid $token-colors-secondary;
        display: flex;
        justify-content: flex-end;

        @include breakpoint (tablet) {
            border-bottom: none;
            padding-bottom: 0;
            justify-content: flex-start;
        }
    }
}
</style>
